import {
  CREATE_ORGANIZATION,
  UPDATE_ORGANIZATION,
  FETCH_ORGANIZATION_FILTERS,
  FETCH_PLATE_WELLS,
  UPDATE_SPECIMEN_TAG_OPTIONS,
  UPDATE_ALGORITHM_CONFIDENCE,
  FETCH_USER_ORGANIZATIONS,
} from "./types";

import {
  displaySuccessNotification,
  displayErrorNotification,
} from "./notifications";

export const createOrganization =
  (sendRequest, uuid, address, gps, name, vectortypes, address_details) => async (dispatch) => {
    const res = await sendRequest("post")({
      url: `/org`,
      devPort: 5005,
      data: { uuid, address, gps, name, vectortypes, address_details },
    }).catch((err) => {
      dispatch(displayErrorNotification("Failed to create org..."));
    });
    if (res?.status === 200) {
      dispatch({
        type: CREATE_ORGANIZATION,
        payload: res.data,
      });

      dispatch(
        displaySuccessNotification(`Successfully created organization ${uuid}`)
      );
    }
  };

export const updateOrganization =
  (sendRequest, uuid, address, gps, name, vectortypes, address_details) => async (dispatch) => {
    const res = await sendRequest("put")({
      url: `/org`,
      devPort: 5005,
      data: { uuid, address, gps, name, vectortypes, address_details },
    }).catch((err) => {
      dispatch(displayErrorNotification("Failed to create org..."));
    });
    if (res?.status === 200) {
      dispatch({
        type: UPDATE_ORGANIZATION,
        payload: res.data,
      });

      dispatch(
        displaySuccessNotification(`Successfully created organization ${uuid}`)
      );
    }
  };

/**
 * The organizations this user may act as, in IDX.
 *
 * The memberships on the token carry only slugs; the display names live in the
 * backend's own database, and a superuser's list is not on the token at all.
 * The response is already filtered to what the backend will actually serve, so
 * the picker cannot offer something that would then be refused.
 */
export const fetchUserOrganizations = (sendRequest) => async (dispatch) => {
  const response = await sendRequest("get")({
    url: "/organizations/user",
    isOrganizationAPI: true,
  }).catch((err) => {
    console.error("Error in GET /organizations/user", err);
  });
  if (response?.data) {
    dispatch({
      type: FETCH_USER_ORGANIZATIONS,
      payload: response.data?.organizations || [],
    });
  }
};

export const fetchOrganizationFilters = (sendRequest) => async (dispatch) => {
  const response = await sendRequest("get")({
    url: "/organization/filters",
    isOrganizationAPI: true,
  });
  if (response) {
    let body = response?.data;
    if (body?.body) {
      body = body.body;
      if (typeof body === "string") {
        body = JSON.parse(body);
      }
    }
    // const data = JSON.parse(body);
    dispatch({ type: FETCH_ORGANIZATION_FILTERS, payload: body });
  }
};

export const fetchPlateWells = (plate, sendRequest) => async (dispatch) => {
  if (plate) {
    const response = await sendRequest("get")({
      url: `/organization/plate/${plate}/wells`,
      isOrganizationAPI: true,
    });
    dispatch({
      type: FETCH_PLATE_WELLS,
      debug: "fetch",
      payload: { plate, wells: response.data },
    });
  }
};

export const updatePlateWells = (plate, wells) => async (dispatch) => {
  dispatch({
    type: FETCH_PLATE_WELLS,
    debug: "update",
    payload: { plate, wells },
  });
};

export const updateSpecimenTagOptions = (tags) => async (dispatch) => {
  dispatch({
    type: UPDATE_SPECIMEN_TAG_OPTIONS,
    payload: tags,
  });
};

export const updateAlgConfidenceSettings = (vectorType, confidence) => async (dispatch) => {
  console.log('i got called')
  dispatch({
    type: UPDATE_ALGORITHM_CONFIDENCE,
    payload: {
      vectorType, confidence
    }
  });
}